module.exports = __webpack_public_path__ + "img/compare.29c7fea4.svg";